<template>
  <v-row>
    <v-radio-group class="ma-5" v-model="radioGroup" @change="selectionChange()">
      <v-radio v-for="reportType in reportTypes" :key="reportType" :label="reportType" :value="reportType"></v-radio>
    </v-radio-group>
    <v-btn @click="send" class="ma-5">
      Send getReport
    </v-btn>
  </v-row>
</template>
<script>
let reportTypes = {
  FULL: 'full',
  BDD: 'bdd',
  LOGS: 'logs',
};
export default {
  data: () => ({
    reportTypes: Object.keys(reportTypes),
    radioGroup: null,
    dataToSend: null,
  }),
  methods: {
    selectionChange: function () {
      this.dataToSend = reportTypes[this.radioGroup];
    },
    send: function () {
      this.$emit('sendGetReport', this.dataToSend);
    }
  }
}
</script>